import React from 'react'
import { Icon, Heading, List } from 'lib/ui'

const Social = ({}) => {
  return (
    <>
      <Heading inverted as="h4" content="Social" />
      <List link inverted horizontal>
        <List.Item
          as="a"
          href="https://www.facebook.com/RecallMonitorCA"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Icon link name="facebook f" size="large" />
        </List.Item>
        <List.Item
          as="a"
          href="https://twitter.com/RecallMonitorCA"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Icon link name="twitter" size="large" />
        </List.Item>
        <List.Item
          as="a"
          href="https://ca.pinterest.com/RecallMonitorCA/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Icon link name="pinterest" size="large" />
        </List.Item>
      </List>
    </>
  )
}

export default Social
